import React from 'react';
import { CheckIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function Problem() {
  return <section className="w-full bg-cream py-14 md:py-24" data-id="element-137" data-mp="2pe7ge8brzt7e">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-138" data-mp="2bfzk82mkcvxa">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-139" data-mp="2bffzke5j3tfk">
          ¿Te gustaría vivir octubre de una manera diferente?
        </h2>

        <ul className="mx-auto mt-10 max-w-2xl space-y-3 md:mt-12" data-id="element-140" data-mp="21ntja3ec345y">
          {painPoints.map(point => <li key={point} className="flex items-start gap-4 rounded-2xl bg-ivory px-5 py-4 ring-1 ring-line" data-id="element-141" data-mp="26ihawb4mweor">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-parchment text-gold ring-1 ring-gold/40" data-id="element-142" data-mp="1wrv0cvbryecx">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-143" data-mp="1itekoevxpdin" />
              </span>
              <span className="font-medium leading-snug text-ink" data-id="element-144" data-mp="1ns7vfzju6qf4">{point}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-2xl font-semibold leading-snug text-ink md:text-4xl" data-id="element-145" data-mp="oau6ucngpe7j">
          No necesitas hacer más.
          <br data-id="element-146" data-mp="129txtqyg656v" />
          <span className="italic text-wine" data-id="element-147" data-mp="12893a1c4um90">Necesitas tener tu momento preparado.</span>
        </p>
      </div>
    </section>;
}